import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, take } from 'rxjs';

import { AccountService } from 'app/core';
import { FieldUsageResult } from './custom-field-dialog.types';

@Injectable()
export class CustomFieldDialogService {
  private get accountId(): number {
    return Number(this.accountService.getCurrentAccount()?.id);
  }

  constructor(private readonly httpClient: HttpClient, private readonly accountService: AccountService) {}

  public getUsage(fieldName: string, relatedToType: string): Observable<FieldUsageResult> {
    const params = new HttpParams().append('account_id', this.accountId).append('related_to_type', relatedToType);
    return this.httpClient.get<FieldUsageResult>(`fields/usages?name=${fieldName}`, { params }).pipe(take(1));
  }
}
